import React from 'react';
import toast from 'react-hot-toast';
import useHttp from '@/hooks/useHttp';
import { getCookie } from 'cookies-next';
import useHttpV2 from '@/hooks/useHttpv2';
import Input from '@/components/inputs/input';
import { formatToBRL } from '@/helpers/formatter';
import { AuthContext } from '@/contexts/auth-context';
import { useConfig } from '@/contexts/config-context';
import { useParams, useRouter, useSearchParams } from 'next/navigation';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { green } from '@mui/material/colors';
import { DatePicker } from '@mui/x-date-pickers';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Info, Close, Warning, ShoppingCart, ArrowCircleRight } from '@mui/icons-material';
import { Box, Fade, Grid, Alert, Avatar, Divider, Checkbox, IconButton, Typography, CircularProgress } from '@mui/material';

import ModalTerms from './modal-terms';
import InputMask from '../inputs/input-mask';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Fade ref={ref} {...props} />;
});

const fieldsToShow = {
    "phone": {
        label: "Telefone",
        mask: "(99) 9 9999-9999"
    },
    "cpf": {
        label: "CPF",
        mask: "999.999.999-99"
    },
}

export default function ModalCheckout({
    open,
    onClose,
    value,
    raffle,
    // data,
    // setData,
    quantity,
    setQuantity,
    selectedNumbers = [],
    promotionId,
    setUpsellPromotions,
    upsellPromotions
}) {
    const config = useConfig();
    const [data, setData] = React.useState({
        value: "",
        cpf: "",
        email: "",
        name: "",
        birth_date: null,
        social_name: "",
    });
    const { post } = useHttp();
    const searchParams = useSearchParams();
    const context = React.useContext(AuthContext);
    const [mode, setMode] = React.useState("login");
    const [affiliateCode, setAffiliateCode] = React.useState(null);

    const getClient = async () => {
        // if (String(data.value).replace(/[^\d]/g, "").length < 10) {
        if (String(data[config.login_mode]).replace(/[^\d]/g, "").length < 2) {
            toast.error(`Informe um ${fieldsToShow[config.login_mode]?.label} válido`);
            return;
        }

        let result = await post(`/api/clients/find?value=${data[config.login_mode]}&raffle_slug=${raffle.slug}`);

        if (result == "error") {

            return;
        }
        if (result?.user == null && result !== null) {
            setMode("register");
        } else {
            if (result?.user) {
                localStorage.setItem("token", result?.user?.token)
                context.setUser(result?.user)

                setMode("logged");
            } else {

            }

            // context.refresh();
        }
    };

    const registerClient = async () => {
        if (!data.phone || !data.phone_confirmation) {
            toast.error("Por favor, preencha ambos os campos de telefone");
            return;
        }

        if (data.phone !== data.phone_confirmation) {
            toast.error("Os números de telefone não coincidem");
            return;
        }

        try {
            let result = await post(`/api/clients`, {
                name: data.name,
                phone: data.phone,
                cpf: data?.cpf,
                email: data?.email,
                raffle_slug: raffle.slug,
                birth_date: data.birth_date,
                social_name: data.social_name,
            });
            if (result.user != null && result.user?.token) {
                context.setUser(result.user)
                localStorage.setItem("token", result.user?.token);
                setMode("logged");
                context.refresh();
            }
        } catch (e) {
            console.log(e)
        }
    };

    const handleClose = () => {
        onClose();
    };

    const handleConfirmLogin = async () => {
        // if (!context.user) {
        await getClient()
        // }
    }

    const handleConfirmRegister = async () => {
        // if (!context.user) {
        await registerClient();
        // }
    };

    React.useEffect(() => {
        if (context.user) {
            setMode("logged");
        } else if (!context.user) {
            setMode("login");
        }
    }, [context.user]);

    React.useEffect(() => {
        setAffiliateCode(searchParams.get("i"));
    }, []);

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>
                <Box sx={{ display: "flex", height: 5, justifyContent: "space-between", alignContent: "center", alignItems: "center" }} className='flex items-center justify-between'>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignContent: "center", alignItems: "center" }}>
                        <ShoppingCart /> <b>Checkout</b>
                    </Box>
                    <IconButton onClick={handleClose}>
                        <Close />
                    </IconButton>
                </Box>
            </DialogTitle>
            <Divider />
            {
                mode == "logged" ?
                    <LoggedContent
                        open={open}
                        setMode={setMode}
                        onClose={onClose}
                        value={value}
                        raffle={raffle}
                        data={data}
                        setData={setData}
                        quantity={quantity}
                        setQuantity={setQuantity}
                        promotionId={promotionId}
                        setUpsellPromotions={setUpsellPromotions}
                        upsellPromotions={upsellPromotions}
                        affiliateCode={affiliateCode}
                        selectedNumbers={selectedNumbers}
                    /> : mode == "login" ?
                        <LoginContent
                            setMode={setMode}
                            handleConfirm={handleConfirmLogin}
                            onClose={onClose}
                            value={value}
                            raffle={raffle}
                            data={data}
                            setData={setData}
                            affiliateCode={affiliateCode}
                            selectedNumbers={selectedNumbers}
                        />
                        :
                        <RegisterContent
                            setMode={setMode}
                            open={open}
                            data={data}
                            setData={setData}
                            handleConfirm={handleConfirmRegister}
                            onClose={onClose}
                            value={value}
                            raffle={raffle}
                            affiliateCode={affiliateCode}
                            selectedNumbers={selectedNumbers}
                        />
            }

        </Dialog>
    );
}

const RegisterContent = ({
    handleConfirm,
    onClose,
    value,
    raffle,
    data,
    setData,
    affiliateCode,
    selectedNumbers
}) => {
    const [loading, setLoading] = React.useState(false);

    const innerConfirm = async () => {
        setLoading(true);
        try {
            await handleConfirm();
        } finally {
            setLoading(false);

        }
    }

    return (
        <>
            <DialogContent>
                <Alert color='info' icon={<Info />} sx={{
                    display: "flex",
                    justifyContent: "center",
                    my: 3
                }}>Você está adquirindo <b>{value}</b> unidade(s) do produto <b>{raffle.title}</b>
                    {
                        affiliateCode &&
                        <>&nbsp;pelo código <b>{affiliateCode}</b></>
                    }
                    {
                        selectedNumbers.length > 0 &&
                        <>
                            <br />
                            Seus números: <b>{selectedNumbers.join(', ')}</b>
                        </>
                    }
                </Alert>
                {
                    raffle.cpf_is_required &&
                    <InputMask
                        style={{ marginBottom: 10 }}
                        className="my-4"
                        label="CPF*"
                        value={data.cpf}
                        mask={"999.999.999-99"}
                        onChange={e => setData({
                            ...data,
                            cpf: e.target.value
                        })}
                    />
                }

                <Input
                    style={{ marginBottom: 15 }}
                    label="Nome completo*"
                    value={data.name}
                    onChange={e => setData({
                        ...data,
                        name: e
                    })}
                />
                {
                    raffle?.social_name_is_required &&
                    <Input
                        style={{ marginBottom: 15 }}
                        label="Nome social"
                        value={data.social_name}
                        onChange={e => setData({
                            ...data,
                            social_name: e
                        })}
                    />
                }
                {
                    raffle?.birth_date_is_required &&
                    <DatePicker
                        label="Data de nascimento"
                        value={data.birth_date}

                        sx={{ marginBottom: 2, width: "100%" }}
                        onChange={e => setData({
                            ...data,
                            birth_date: e
                        })}
                    />
                }

                <Grid container spacing={1}>
                    <Grid item sx={{ width: "100%" }} sm={6}>
                        <InputMask
                            style={{ marginBottom: 15 }}
                            className="my-4"
                            mask={"(99) 9 9999-9999"}
                            label="Informe seu telefone*"
                            value={data.phone}
                            onChange={e => setData({
                                ...data,
                                phone: e.target.value
                            })}
                            shrink
                        />
                    </Grid>
                    <Grid item sx={{ width: "100%" }} sm={6}>
                        <InputMask
                            style={{ marginBottom: 15 }}
                            className="my-4"
                            mask={"(99) 9 9999-9999"}
                            label="Confirme seu telefone*"
                            value={data.phone_confirmation}
                            onChange={e => setData({
                                ...data,
                                phone_confirmation: e.target.value
                            })}
                            error={data.phone && data.phone_confirmation && data.phone !== data.phone_confirmation}
                            helperText={data.phone && data.phone_confirmation && data.phone !== data.phone_confirmation ? "Os números de telefone não coincidem" : ""}
                        />
                    </Grid>
                </Grid>
                {
                    raffle.email_is_required &&
                    <Input
                        className="my-4"
                        label="E-mail*"
                        value={data.email}
                        onChange={e => setData({
                            ...data,
                            email: e
                        })}
                    />
                }

                <Alert style={{ marginTop: 10, marginBottom: 10 }} severity='warning' icon={<Warning />}>Informe seu telefone para continuar.</Alert>
                <small style={{
                    color: "rgb(108, 117, 125)"
                }}>Ao realizar este pagamento e confirmar minha compra desse título de capitalização, declaro ter lido e concordado com os termos desta anexados na página do sorteio.</small>
            </DialogContent>
            <DialogActions>
                <Button
                    disabled={loading}
                    style={{
                        height: 45
                    }} variant='contained' color='primary' fullWidth onClick={innerConfirm}>
                    {loading && <CircularProgress size={20} className='mr-2' />}
                    <b>Concluir reserva</b> <ArrowCircleRight /></Button>
            </DialogActions>
        </>
    );
};

const LoginContent = ({
    handleConfirm,
    value,
    raffle,
    data,
    setData,
    affiliateCode,
    selectedNumbers
}) => {
    const config = useConfig();
    const [loading, setLoading] = React.useState(false);

    const innerConfirm = async () => {
        setLoading(true);

        await handleConfirm();
        setLoading(false);
    }

    return (
        <>
            <DialogContent>
                <Alert severity="info" icon={<Info />} sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                    Você está adquirindo <b>{value}</b> unidade(s) do produto <b>{raffle.title}</b>
                    {
                        affiliateCode &&
                        <>&nbsp;pelo código <b>{affiliateCode}</b></>
                    }
                    {
                        selectedNumbers.length > 0 &&
                        <>
                            <br />
                            Seus números: <b>{selectedNumbers.join(', ')}</b>
                        </>
                    }
                </Alert>
                <InputMask
                    className="my-4"
                    label={`Informe seu ${fieldsToShow[config.login_mode]?.label}`}
                    value={data[config.login_mode]}
                    mask={fieldsToShow[config.login_mode]?.mask}
                    onChange={e => setData({ ...data, [config.login_mode]: e.target.value })}
                />
                <Alert sx={{ my: 2 }} severity="warning" icon={<Warning />}>
                    Informe seu {fieldsToShow[config.login_mode]?.label} para continuar.
                </Alert>
                <Typography variant="body2" color="textSecondary">
                    Ao realizar este pagamento e confirmar minha compra desse título de capitalização, declaro ter lido e concordado com os termos desta anexados na página do sorteio.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    disabled={loading}
                    sx={{ height: 45 }}
                    variant="contained"
                    color="success"
                    fullWidth
                    onClick={innerConfirm}
                >
                    {loading && <CircularProgress size={20} sx={{ marginRight: 2 }} />}
                    <b>Concluir reserva</b> <ArrowCircleRight />
                </Button>
            </DialogActions>
        </>
    );
};

const LoggedContent = ({
    value,
    raffle,
    data,
    setData,
    quantity,
    promotionId,
    setMode,
    setQuantity,
    setUpsellPromotions,
    upsellPromotions,
    affiliateCode,
    selectedNumbers,

}) => {
    const config = useConfig();
    const { post } = useHttpV2();
    const searchParams = useSearchParams()
    const context = React.useContext(AuthContext);
    const [loading, setLoading] = React.useState(false);
    const params = useParams();
    const router = useRouter();
    const [upsellQuantity, setUpsellQuantity] = React.useState(0);
    const isMobile = localStorage.getItem('is_mobile') == 'true';

    function formatPhoneNumber(number) {
        if (!number) {
            return;
        }
        // Convert the number to a string
        const numStr = number.toString();

        // Use a regular expression to capture the parts of the number
        const formattedNumber = numStr.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})$/, "($1) $2 $3-$4");

        return formattedNumber;
    }

    const generatePayment = async () => {
        setLoading(true);
        let response = await post(`/api/payment/${params.id}/generate`, {
            quantity: quantity,
            promotion_id: promotionId,
            affiliate_code: affiliateCode ? affiliateCode : getCookie("indicated_by"),
            upsell_promotions: upsellPromotions,
            selected_numbers: selectedNumbers,
            is_mobile: isMobile,
            cpf: data.cpf,
            social_name: data.social_name,
            birth_date: data.birth_date,
            utm_source: searchParams.get("utm_source"),
            fbclid: searchParams.get("fbclid")
        }, false, false);

        if (!response.hasError && response.data.payment) {
            router.push(`/payment/${response.data.payment.identifier}`);
        }

        if (response.hasError && response.statusCode == 400) {
            setLoading(false);
        }
        if (response.hasError && response.statusCode == 500) {
            toast.error(response.errorMessage)
            setLoading(false);
        }
        if (response.hasError && response.statusCode == 401) {
            await context.refresh();

            setLoading(false);
            setMode("login");
        }
    };

    const logout = () => {
        window.localStorage.removeItem("token")
        setMode("login");
    };

    const hasPromotion = () => raffle.allow_promotion && raffle.upsell_promotions.some(el => el.is_upsell == true);

    return (
        <>
            <DialogContent>
                <Alert severity="info" icon={<Info />} sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
                    Você está adquirindo <b>{value}</b> {upsellQuantity > 0 ? <>+ <b>{upsellQuantity}</b></> : ""} unidade(s) do produto <b>{raffle.title}</b>
                    {
                        affiliateCode &&
                        <>&nbsp;pelo código <b>{affiliateCode}</b></>
                    }
                    {
                        selectedNumbers.length > 0 &&
                        <>
                            <br />
                            Seus números: <b>{selectedNumbers.join(', ')}</b>
                        </>
                    }
                </Alert>
                {
                    hasPromotion() && (raffle.allow_promotion && raffle.upsell_promotions.some(el => el.is_upsell == true)) &&
                    raffle.upsell_promotions.map((el, index) => {
                        if (el.show_from_numbers != 0 && quantity < el.show_from_numbers) {
                            return;
                        }
                        if (el.show_from_numbers != 0 && quantity > el.show_to_numbers) {
                            return;
                        }

                        return (
                            <Box key={index} sx={{ mt: -6 }}>
                                <img style={{
                                    position: "relative",
                                    width: 80,
                                    top: 28
                                }} src='/oferta_especial.png' />
                                <Box
                                    label="Upsell"
                                    key={index + "l"}
                                    sx={{
                                        marginBottom: 3,
                                        borderColor: green[500],
                                        borderWidth: 2,
                                        borderStyle: "solid",
                                        borderRadius: 2,
                                        height: 80,
                                        display: "flex",
                                        alignItems: "center",
                                        backgroundColor: "rgb(144, 238, 144, .05)"
                                    }}>
                                    <Checkbox size='large' onChange={(e) => {
                                        let tempQuantity = quantity;
                                        let updatedPromotions = [...upsellPromotions]; // Make a copy of the promotions array

                                        if (e.target.checked) {
                                            tempQuantity += el.numbers_quantity;
                                            setUpsellQuantity(upsellQuantity + el.numbers_quantity);
                                            updatedPromotions.push(el.id); // Add promotion ID
                                        } else {
                                            tempQuantity -= el.numbers_quantity;
                                            setUpsellQuantity(upsellQuantity - el.numbers_quantity);
                                            updatedPromotions = updatedPromotions.filter(item => item !== el.id); // Remove promotion ID
                                        }

                                        setUpsellPromotions(updatedPromotions); // Update promotions list
                                    }} />
                                    <Box sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "flex-start",

                                    }}>
                                        <Typography variant="body1" color="textPrimary">Deseja <b>+{el.numbers_quantity}</b> títulos por apenas <b>{formatToBRL(el.value)}</b>?</Typography>
                                        {!!el?.description && <Typography className='gelatine' fontWeight={600} variant="body2" color="textPrimary">{el?.description}</Typography>}
                                    </Box>
                                </Box>
                                <Box style={{ width: "100%" }}>
                                    {
                                        !!el?.image_path &&

                                        <img
                                            className='gelatine'
                                            src={el.image_path}
                                            style={{
                                                position: "relative",
                                                width: 80,
                                                float: "right",
                                                marginTop: -76,
                                                objectFit: "cover",
                                                right: -15
                                            }}
                                        />
                                    }
                                </Box>

                            </Box>
                        );
                    })
                }

                <Box display="flex" gap={2} mt={2} mb={2} alignItems="center">
                    <Avatar
                        sx={{
                            borderRadius: 1,
                            width: 53,
                            height: 53
                        }} src='/user.jpg' />
                    <Box display="flex" flexDirection="column">
                        <Typography fontWeight="bold" variant='h6'>{context.user?.name}</Typography>
                        <Typography>{formatPhoneNumber(context.user?.phone)}</Typography>
                    </Box>



                </Box>
                <CompleteData
                    raffle={raffle}
                    data={data}
                    setData={setData}
                    user={context.user}
                />

                <Divider sx={{ mt: 2 }} />

                <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
                    Ao realizar este pagamento e confirmar minha compra desse título de capitalização, declaro ter lido e concordado com os {config?.capitalizadora_show_terms ? <ModalTerms open={true} /> : "Termos de Utilização"} desta anexados na página do sorteio.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ display: "flex", flexDirection: "column" }}>
                <Button
                    sx={{ height: 45 }}
                    disabled={loading}
                    variant="contained"
                    color="success"
                    fullWidth
                    onClick={generatePayment}
                    type='button'
                >
                    {loading && <CircularProgress size={20} sx={{ marginRight: 2 }} />}
                    <b>Concluir reserva</b> <ArrowCircleRight />
                </Button>
                <Button sx={{ mt: 2, color: green[500] }} fullWidth variant='text' color='success' onClick={logout} >Alterar conta</Button>
            </DialogActions>
        </>
    );
};


const CompleteData = ({ raffle, data, setData, user }) => {
    const hasAnyDataMissing = () => {
        if (raffle.cpf_is_required && !user.cpf) {
            return true
        }
        return false
    }

    return (
        <>
            {
                hasAnyDataMissing() &&
                <Divider sx={{ mt: 2, mb: 2 }}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                        }}
                    >
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "text.secondary" }}>
                            Complete seus dados
                        </Typography>
                    </Box>
                </Divider>
            }

            <Box >
                {
                    (raffle.cpf_is_required && !user.cpf) &&
                    <InputMask
                        style={{ marginBottom: 10 }}
                        className="my-4"
                        label="CPF*"
                        value={data.cpf}
                        mask={"999.999.999-99"}
                        onChange={e => setData({
                            ...data,
                            cpf: e.target.value
                        })}
                    />
                }
                {
                    (raffle?.social_name_is_required && !user.social_name) &&
                    <Input
                        style={{ marginBottom: 15 }}
                        label="Nome social"
                        value={data.social_name}
                        onChange={e => setData({
                            ...data,
                            social_name: e
                        })}
                    />
                }
                {
                    (raffle?.birth_date_is_required && !user.birth_date) &&
                    <DatePicker
                        label="Data de nascimento"
                        value={data.birth_date}

                        sx={{ marginBottom: 2, width: "100%" }}
                        onChange={e => setData({
                            ...data,
                            birth_date: e
                        })}
                    />
                }
            </Box>
        </>
    );
}
